<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="px-4">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="#">
                    <!-- <img v-lazy="" class="rounded-circle"> -->
                    <img
                      :src=" this.orgInfo.logo != null ?  (this.imageURL+this.orgInfo.logo) : defaultImage"
                      class="rounded-circle"
                    />
                  </a>
                </div>
              </div>
              <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center pd-0">
                <div class="card-profile-actions py-4 mt-lg-0 pd-0">
                  <base-button type="info" size="md" class="mr-4">{{$t('Share')}}</base-button>
                  <base-button
                    @click="$bvModal.show('modal-userInfo')"
                    type="default"
                    size="md"
                    class="float-right"
                  >{{$t('Donate_Now')}}</base-button>
                  <BankDetails></BankDetails>
                </div>
              </div>
              <div class="col-lg-4 order-lg-1">
                <div class="card-profile-stats d-flex justify-content-center">
                  <div>
                    <span
                      class="heading"
                    >&#8381; {{orgInfo && orgInfo.organization_campaign_stats ? orgInfo.organization_campaign_stats.campaign_count : 'NA'}}</span>
                    <span class="description">{{$t('Total_Projects')}}</span>
                  </div>
                  <div>
                    <span
                      class="heading"
                    >&#8381; {{orgInfo && orgInfo.organization_campaign_stats ? orgInfo.organization_campaign_stats.organization_fund_collected : 'NA'}}</span>
                    <span class="description">{{$t('Received_Amount')}}</span>
                  </div>
                  <div>
                    <span
                      class="heading"
                    >&#8381; {{orgInfo && orgInfo.organization_campaign_stats ? orgInfo.organization_campaign_stats.organization_fund_used : 'NA'}}</span>
                    <span class="description">{{$t('Spend_Amount')}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mt-5">
              <h3>{{orgInfo ? orgInfo.name : 'NA'}}</h3>
              <div class="h6 font-weight-300">{{orgInfo ? orgInfo.tagline : 'NA'}}</div>
              <div class="h6 mt-4">{{orgInfo ? orgInfo.address : 'NA'}}</div>
              <div>{{orgInfo ? orgInfo.email : 'NA'}}</div>
            </div>
            <div class="mt-5 py-5 border-top text-center">
              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <p>{{orgInfo ? orgInfo.description : 'NA'}}</p>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>
<script>
import BankDetails from "./components/BankDetails";
import axios from "axios";
export default {
  name: "Organization",
  components: {
    BankDetails
  },
  data() {
    return {
      orgInfo: {},
      defaultImage: "img/default-image.png",
      imageURL: "http://88.99.171.147:3000/api/file/"
    };
  },
  methods: {
    getOrganizationDetails(id) {
      const token = localStorage.getItem("token");
      // if(!id){
      //   return
      // }
      axios({
        method: "get",
        url: process.env.VUE_APP_API_URL + `/organizations/default`,
        headers: { Authorization: ` ${token}` }
      })
        .then(Response => {
          if (Response) {
            this.orgInfo = Response.data || {};
            console.log("org info", this.orgInfo);
          }
        })
        .catch(error => this.$toasted.show(error));
    }
  },
  mounted() {
    this.getOrganizationDetails();
  }
};
</script>
<style>
</style>
